// extracted by mini-css-extract-plugin
export default {"footer":"MainFooter_footer__76P4E","box":"MainFooter_box__QNQWa","footerLinks":"MainFooter_footerLinks__3K1XK","footerLink":"MainFooter_footerLink__rHk8h"};